import { Nullable } from '@ps/utils';

const EXCLUSION_PERIOD_MIN_DAYS = 1;
const EXCLUSION_PERIOD_MAX_DAYS = 365;
export const DEFAULT_EXCLUSION_PERIOD_DAYS = 90;

export function clampBuyerExclusionPeriodDefault(
  value: Nullable<number> | undefined,
): Nullable<number> {
  if (typeof value !== 'number') {
    return null;
  }
  return value >= EXCLUSION_PERIOD_MIN_DAYS &&
    value <= EXCLUSION_PERIOD_MAX_DAYS
    ? value
    : null;
}

export function exclusionPeriodDefaultOrFallback(
  buyerExclusionPeriodDefault: Nullable<number> | undefined,
): number {
  return (
    clampBuyerExclusionPeriodDefault(buyerExclusionPeriodDefault) ??
    DEFAULT_EXCLUSION_PERIOD_DAYS
  );
}
